import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./header.css";
import logo from "./../../Images/logo.jpg";
import logo2 from "./../../Images/scopus.jpg";
import logo3 from "./../../Images/DBLP_Logo.jpg";
import logo4 from "./../../Images/logo_springer_lncs.png";

export const Header = () => {
  return (
    <>
      <div className="header-box"></div>
      <div className="header-box-2">
          <Link className="header-link-2" to="https://link.springer.com/book/10.1007/978-3-031-27199-1">
            Springer.com
          </Link>
          <Link className="header-link" to="https://link.springer.com/conference/ihci">IHCI Preview</Link>
          <Link className="header-link" to="http://micro.daegucvb.com/Main/?CID=780">IHCI 2020</Link>
          <Link className="header-link" to="https://www.ihci.cs.kent.edu/">IHCI 2021</Link>
          <Link className="header-link" to="https://t.me/+a3g1XOK2Pe1lMmU1">
            Telegram
          </Link>
          <Link className="header-link"
            to="https://www.facebook.com/IHCI2020/?ref=page_internal"
          >
            Facebook
          </Link>
          <Link className="header-link"
            to="https://www.youtube.com/channel/UCW1rb1Xn25FwyoJOjAfUpFw"
          >
            Youtube
          </Link>
      </div>
      <Navbar className="custom-navbar" variant="dark">
        <div className="abc">
        <Link to="/">
          <Navbar.Brand>
            <img src={logo} alt="Logo" className="logo" />
          </Navbar.Brand>
        </Link>
        <Navbar.Collapse
          id="basic-navbar-nav"
          className=" header-info-box"
        >
          <Navbar.Text>
            <h4 style={{ color: "grey" }}>
              15th International Conference on IHCI-2023
            </h4>
            <h6 style={{ color: "grey" }}>
              Exco, Daegu, Korea, November 08 - 10, 2023
            </h6>
          </Navbar.Text>
        </Navbar.Collapse>
        </div>
        <div className="abd justify-content-end">
        <Link to="/">
          <Navbar.Brand>
            <img src={logo2} alt="Logo" className="logo-2" />
          </Navbar.Brand>
        </Link>
        <Link to="/">
          <Navbar.Brand>
            <img src={logo3} alt="Logo" className="logo-2" />
          </Navbar.Brand>
        </Link>
        <Link to="/">
          <Navbar.Brand>
            <img src={logo4} alt="Logo" className="logo" />
          </Navbar.Brand>
        </Link>
        </div>
      </Navbar>
    </>
  );
};
